import React, {useState, useRef} from "react";
import "../Teamsliderstyle.scss";
import TeamData from "../TeamData";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// import required modules
import { EffectCreative, FreeMode, Navigation, Thumbs } from 'swiper/modules';


const TeamSection =()=> {

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return(
        <>
            <section className="team-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="title">
                                <h2>Our Team</h2>    
                                <button className="btn-2"><a href="/team">View our team</a></button>
                            </div>                        
                        </div>
                    </div>
                </div>

                <div className="slide-container container" style={{padding:'40px 0 0 0'}}>
                    <div className="">
                        <div className='tw-w-full slider !p-0'>  
                            <svg width="0" height="0">
                                {/* <clipPath id="curvedClip" clipPathUnits="objectBoundingBox">
                                    <path d="M1,0
                                        C0.8,0 0.7,0.1 0.7,0.2
                                        L0.7,0.8
                                        C0.7,0.9 0.8,1 1,1
                                        L0.18,1
                                        L0.10,0.85
                                        L0.03,0.85
                                        L0,0.80
                                        L0,0
                                        Z"/>
                                </clipPath> */}
                                

                            </svg>                                  
                            <div className='team-slider'>
                                <Swiper
                                    style={{
                                    '--swiper-navigation-color': '#fff',
                                    '--swiper-pagination-color': '#fff',
                                    }}
                                    loop={true}
                                    spaceBetween={100}
                                    navigation={{
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current,
                                    }}
                                    onInit={(swiper) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                    }}
                                    centeredSlides={true}
                                    autoplay={{delay:4000,disableOnInteraction:false,pauseOnMouseEnter: false,}}  
                                    thumbs={{ swiper: thumbsSwiper }}
                                    modules={[FreeMode, Navigation, Thumbs, EffectCreative]}
                                    // grabCursor={true}
                                    // effect={'creative'}
                                    // creativeEffect={{
                                    // prev: {
                                    //     shadow: true,
                                    //     translate: ['-100%', 0, -500],
                                    // },
                                    // next: {
                                    //     translate: ['100%', 10, -500],
                                    // },     
                                    // speed: 800
                                    // }}
                                    className="mySwiper2"
                                >
                                    {
                                        TeamData.map((obj)=>{
                                            return(
                                                <SwiperSlide> 
                                                    <div className="row" key={obj.id}>
                                                        <div className="col-xl-4 col-lg-4 col-12">
                                                            <img src={obj.img} alt="" className="teamimg"/>
                                                        </div>
                                                        <div className="col-xl-8 col-lg-8 col-12 d-flex align-items-center">
                                                            <div className="tw-pr-6">
                                                                <div className="team-member-short-info">
                                                                    <div className="member-name">
                                                                        <h3>{obj.name}</h3>
                                                                        <h4>{obj.title}</h4>
                                                                    </div>
                                                                </div>
                                                                <div className="team-member-brief">  
                                                                    <div className="team-about-text">    
                                                                        <p>{obj.about}</p>
                                                                    </div>  
                                                                    <button className="btn-2-white" style={{padding:'10px 30px',marginTop:'15px'}}>
                                                                        <a href="/team">Read More</a>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                    <div className="swipercustombtn">
                                        <button ref={prevRef} style={{  border: 'none', cursor: 'pointer',zIndex:'9' }}>
                                        {/* Left Arrow SVG */}
                                        <svg width="26" height="10" viewBox="0 0 26 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.5 5H2M2 5L6 1M2 5L6 9" stroke="#157438" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                        </button>
                                        <button ref={nextRef} style={{ border: 'none', cursor: 'pointer' }}>
                                        {/* Right Arrow SVG */}
                                        <svg width="25" height="10" viewBox="0 0 25 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 5H23.5M23.5 5L19.5 1M23.5 5L19.5 9" stroke="#157438" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                        </button>
                                    </div>
                                </Swiper>
                                <Swiper
                                    onSwiper={setThumbsSwiper}
                                    loop={true}
                                    spaceBetween={15}
                                    slidesPerView={4}
                                    freeMode={true}
                                    watchSlidesProgress={true}
                                    modules={[FreeMode, Navigation, Thumbs]}
                                    className="mySwiper"
                                    slideToClickedSlide={true}
                                >
                                    {
                                        TeamData.map((obj)=>{
                                            return(
                                                <SwiperSlide> 
                                                    <div className="teamimgwrapper" key={obj.id}>
                                                        <img src={obj.img} alt="" />
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }                                
                                </Swiper>                                
                            </div>                    
                        </div>                        
                    </div>
                </div>
            </section>
        </>
    )
}

export default TeamSection;